import axios from 'axios';

export default {
  state: {},
  mutations: {},
  actions: {
    async declineOffer({ commit }, params) {
      let result;
      await axios
        .post(`/api/offers/decline`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async cancelOffer({ commit }, params) {
      let result;
      await axios
        .post(`/api/offers/cancel`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async sendOffer({ commit }, params) {
      let result;
      await axios
        .post(`/api/offers/friendship`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async acceptOffer({ commit }, params) {
      let result;
      await axios
        .post(`/api/offers/accept`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async deleteFriend({ commit }, params) {
      let result;
      await axios
        .post(`/api/offers/delete`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
  },
  getters: {
    // getSearchUsers: s => s.searchusers
  },
};
